import React from 'react';
import searchIcon from '../../icons/search-normal.svg';

const styles = {
  inputContainer: {
    height: '45px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f9f9f9',
    padding: '16px',
    borderRadius: '12px',
  },
  searchIcon: {
    color: 'gray',
    marginRight: '10px',
  },
  input: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    width: '100%',
    fontWeight: '300',
    fontSize: '16px',
    color: '#222',
  },
  placeholder: {
    color: '#c1c1c1',
  },
};

const SearchInput = ({ placeholder, onChange, value, ...props }) => {
  return (
    <div style={styles.inputContainer}>
      <img src={searchIcon} alt="Search" style={styles.searchIcon} />
      <input type="text" style={styles.input} placeholder={placeholder} onChange={onChange} value={value} {...props} />
    </div>
  );
};

export default SearchInput;
